import { render, staticRenderFns } from "./TypeList.vue?vue&type=template&id=7a46f7b7&"
import script from "./TypeList.vue?vue&type=script&lang=ts&"
export * from "./TypeList.vue?vue&type=script&lang=ts&"
import style0 from "./TypeList.vue?vue&type=style&index=0&id=7a46f7b7&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports